"use client";

import { memo } from "react";
import { AgentMarkdown } from "@/components/desktop/agent/AgentMarkdown";

function StudioIndicatorReadmeImpl({ markdown }: { markdown: string }) {
  if (!markdown.trim()) {
    return (
      <p className="text-sm text-muted-foreground py-8 text-center">
        No README.md for this project yet.
      </p>
    );
  }
  return (
    <div className="prose-studio min-w-0 px-1 py-2">
      <AgentMarkdown text={markdown} />
    </div>
  );
}

export const StudioIndicatorReadme = memo(StudioIndicatorReadmeImpl);
StudioIndicatorReadme.displayName = "StudioIndicatorReadme";
